module.exports = __webpack_public_path__ + "3d03f181e0d386956b145ea9e39021d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/step1.png
// module id = 869
// module chunks = 3